import { render, staticRenderFns } from "./imgL.vue?vue&type=template&id=77861c65&scoped=true"
var script = {}
import style0 from "./imgL.vue?vue&type=style&index=0&id=77861c65&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77861c65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77861c65')) {
      api.createRecord('77861c65', component.options)
    } else {
      api.reload('77861c65', component.options)
    }
    module.hot.accept("./imgL.vue?vue&type=template&id=77861c65&scoped=true", function () {
      api.rerender('77861c65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgL.vue"
export default component.exports